import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality with update callbacks
serviceWorkerRegistration.register({
  onUpdate: registration => {
    console.log('New version available');
    // The update notification will be shown automatically by the service worker
  },
  onSuccess: registration => {
    console.log('Content is cached for offline use');
  }
}); 